var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "section-wrapper w-100" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("div", { staticClass: "row align-items-end" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("h2", { staticClass: "section-separator-title" }, [
                _vm._v(
                  "\n              " +
                    _vm._s(
                      _vm.$t("direct-to-lender.lenderSubmit.applicationSummary")
                    ) +
                    "\n            "
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-body" },
          [_c("direct-to-lender-app-summary")],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("div", { staticClass: "row align-items-end" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("h2", { staticClass: "section-separator-title" }, [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm.$tc("global.doorr.application", 2)) +
                    "\n            "
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-body lender-submit-wrapper" },
          [
            _c("applications-table", {
              attrs: {
                "selected-type": _vm.selectedMortgage.mortgageType,
                printing: _vm.printingPDF,
              },
              on: {
                select: _vm.setSelectedMortgage,
                "application-pdf": _vm.handlePrintAppPDF,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card" },
        [
          _c("div", { staticClass: "card-header" }, [
            _c("div", { staticClass: "row align-items-end" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h2", { staticClass: "section-separator-title" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("global.doorr.submission")) +
                      "\n            "
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "submission-block",
            _vm._b(
              {
                ref: "submissionBlock",
                attrs: {
                  "application-id": _vm.applicationId,
                  "client-username": _vm.clientUsername,
                  "agent-username": _vm.agentUsername,
                  "missing-filogix-details":
                    _vm.missingFilogixDetailsForSubmission,
                  "access-rights": _vm.accessRights,
                },
                on: {
                  submit: _vm.handleLenderSubmit,
                  "update-lender-name": _vm.updateLenderName,
                },
              },
              "submission-block",
              _vm.selectedMortgage,
              false
            )
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("div", { staticClass: "row align-items-end" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("h2", { staticClass: "section-separator-title" }, [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm.$t("dashboard.submissionHistory.cardTitle")) +
                    "\n            "
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c(
              "submission-history-table",
              _vm._b(
                {
                  ref: "submissionTable",
                  on: {
                    "application-pdf": _vm.handlePrintAppPDF,
                    "lender-note": _vm.handleShowLenderNote,
                  },
                },
                "submission-history-table",
                Object.assign({}, _vm.$props),
                false
              )
            ),
            _vm._v(" "),
            _c("lender-note", {
              attrs: { "current-lender-note": _vm.currentLenderNote },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }